import { authErrorHandler } from '@/services/error/authHandler.js';
import { useAPI } from '@/services/useAPI.js';
import eventBus from '@/utils/eventBus';
import { fetchUserUnreadPosts } from '@/services/apis/postApi';

export default {
  async setRecomendedPosts({ commit }, payload) {
    const params = new URLSearchParams({
      limit: '30',
      showOwnPosts: true,
    });
    if (payload?.data?.label && payload?.data?.label !== 'All') {
      params.set('tag', payload.data.label);
    } else if (payload?.label && payload?.label !== 'All') {
      params.set('tag', payload.label);
    }

    try {
      let response = await fetch(`/api/posts/recommended?${params.toString()}`);

      if (!response.ok) {
        console.error('Network response was not ok:', response.statusText);
        return;
      }

      let posts = await response.json();

      if (posts.statusCode) {
        authErrorHandler(posts.statusCode);
        return;
      }

      if (posts.results) {
        commit('setRecomendedPosts', posts.results);
      } else {
        console.warn('No recommended posts found.');
      }

      return posts;
    } catch (error) {
      console.error('Error fetching recommended posts:', error);
    }
  },

  async setNextPagonationPosts({ commit }, payload) {
    if (!payload) {
      throw new Error('Payload is missing or invalid');
    }

    const params = new URLSearchParams({
      limit: '15',
      after: payload.lastId,
    });

    let response;
    let posts;

    try {
      switch (payload.tab) {
        case 'recomendedPosts':
          params.set('showOwnPosts', true);
          if (payload?.filter && payload?.filter !== 'All') params.set('tag', payload?.filter);
          response = await fetch(`/api/posts/recommended?${params.toString()}`);
          posts = await response.json();
          break;
        case 'followingPosts':
          if (
            payload?.filter &&
            payload?.filter !== 'All' &&
            payload?.filter !== 'Following' &&
            payload?.filter !== 'Monitoring'
          )
            params.set('tag', payload?.filter);
          if (payload?.filter === 'Following') {
            params.set('only', 'positive');
          }
          if (payload?.filter === 'Monitoring') {
            params.set('only', 'negative');
          }
          response = await fetch(`/api/posts/for-you?${params.toString()}`);
          posts = await response.json();
          break;
        case 'onlyUserPosts':
          params.set('channelId', payload.channelId);
          params.set('onlyPosts', 'true');
          response = await fetch(`/api/posts?${params.toString()}`);
          posts = await response.json();
          break;
        case 'userReplies':
          response = await fetch(`/api/users/${payload.authorUserId}/replies?${params.toString()}`);
          posts = await response.json();
          break;
        case 'userReposts':
          response = await fetch(`/api/users/${payload.authorUserId}/reposts?${params.toString()}`);
          posts = await response.json();
          break;
        case 'unreadPosts':
          response = await fetchUserUnreadPosts({
            authorUserId: payload.authorUserId,
            after: payload.lastId,
            limit: 15,
          });
          posts = response;
          break;
        default:
          throw new Error('Unknown tabId');
      }

      if (posts.statusCode) {
        authErrorHandler(posts.statusCode);
      }
      return posts;
    } catch (error) {
      console.error('Error in setNextPagonationPosts:', error);
      throw new Error('Failed to fetch posts. Please try again later.');
    }
  },

  async setSuggestedPosts({ commit }) {
    const params = new URLSearchParams({ limit: '10' }).toString();
    try {
      let response = await fetch(`/api/users/suggested?${params}`);

      if (!response.ok) {
        console.error('Network response was not ok:', response.statusText);
        return;
      }

      let posts = await response.json();
      if (posts.statusCode) {
        authErrorHandler(posts.statusCode);
        return;
      }

      if (posts && posts.length > 0) {
        commit('setPostsSuggested', posts);
      } else {
        console.warn('No suggested posts found.');
      }

      return posts;
    } catch (error) {
      console.error('Error fetching suggested posts:', error);
    }
  },

  async setRecomendedPost({ commit }, payload) {
    commit('setPost', null);
    let response = await fetch(`/api/posts/${payload}`);
    let posts = await response.json();
    if (posts.statusCode) {
      authErrorHandler(posts.statusCode);
    }
    commit('setPost', posts);
  },

  async setForYouPosts({ commit }, payload) {
    const params = new URLSearchParams();
    params.set('limit', '20');
    if (payload?.label && payload?.label !== 'All' && payload?.label !== 'Following' && payload?.label !== 'Monitoring')
      params.set('tag', payload?.label);
    if (payload?.label === 'Following') {
      params.set('only', 'positive');
    }
    if (payload?.label === 'Monitoring') {
      params.set('only', 'negative');
    }

    let response = await fetch(`/api/posts/for-you?${params.toString()}`);
    let posts = await response.json();
    if (posts.statusCode) {
      authErrorHandler(posts.statusCode);
    }
    if (posts.results) {
      commit('setFollowingPosts', posts.results);
    } else {
      console.warn('No following posts found.');
    }
    return posts.results;
  },

  async setUserPosts({ commit }, payload) {
    let params = new URLSearchParams({ limit: '15' }).toString();
    if (payload?.id) {
      params = new URLSearchParams({
        limit: '15',
        authorUserId: payload?.id,
      }).toString();
    }
    let response = await fetch(`/api/posts?${params}`, {
      method: 'POST',
      headers: {
        'X-Sez-Platform': 'web',
      },
    });
    let posts = await response.json();
    if (posts.statusCode) {
      authErrorHandler(posts.statusCode);
    }
    commit('setPosts', posts.results);
  },
  async setProfile({ commit }, id) {
    let response = await fetch(`/api/users/${id}`);
    let profile = await response.json();
    if (profile.statusCode) {
      authErrorHandler(profile.statusCode);
    }
    commit('setProfile', profile);
    return profile;
  },
  async setRepliesPosts({ commit }, payload) {
    // if(payload === "null") return;
    commit('setRepliePost', []);
    let response = await fetch(`/api/posts/${payload}/replies`);
    let posts = await response.json();
    if (posts.statusCode) {
      authErrorHandler(posts.statusCode);
    }
    commit('setRepliePost', posts?.results?.reverse());
  },
  async setUpdateStatus({ commit }, payload) {
    commit('setStatusLoad', payload);
  },
  async setPost(
    { commit },
    {
      title,
      rawText,
      text,
      repostedPostId,
      attachedFileIds,
      isAnyoneCanReply,
      postToTwitter,
      postToBluesky,
      weighInThresholds,
      urls,
      mentions,
      channelId,
      displayedChannelId,
      tags,
      toast,
      isReply,
      isComment,
    },
  ) {
    try {
      let response = await fetch(`/api/posts`, {
        method: 'POST',
        body: JSON.stringify({
          title: title ? title : undefined,
          rawText: rawText ? rawText : undefined,
          text,
          repostedPostId: repostedPostId ? repostedPostId : undefined,
          attachedFileIds: attachedFileIds ? attachedFileIds : undefined,
          isAnyoneCanReply: isAnyoneCanReply,
          channelId: channelId,
          displayedChannelId: displayedChannelId ? displayedChannelId : undefined,
          postToTwitter: postToTwitter,
          mentions: mentions ? mentions : undefined,
          postToBluesky: postToBluesky,
          urls: urls?.[0]
            ? [
                {
                  url: urls[0].url,
                  title: urls[0].title,
                  description: urls[0].description,
                  imageUrl: urls[0].imageUrl,
                  isDisabledPreview: urls[0].isDisabledPreview,
                },
              ]
            : undefined,
          ...(isComment === false ? { isComment: false } : {}),
          tags: tags ? tags : undefined,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.status === 401 || response.status === 403) {
        authErrorHandler(response.status);
      }
      if (response.status === 429) {
        toast.add({
          severity: 'error',
          summary: 'Sorry, you have reached the max number of posts allowed for users with your score',
          life: 7000,
        });
        return response;
      }
      if (!response.ok) {
        response = await response.json();
        toast.add({
          severity: 'error',
          summary: response.message,
          life: 7000,
        });
        return response;
      }

      const data = await response.json();

      if (data.error) {
        console.log('error', data.message);
      } else {
        if (response.ok) {
          if (channelId) {
            commit('addOrgPost', data, { root: true });

            toast.add({
              severity: 'success',
              summary: isReply ? 'Reply created' : 'Post created',
              life: 7000,
            });

            return response;
          }

          const payload = { data: data, type: 'create' };
          localStorage.removeItem('thresholdsPost');
          commit('postPost', payload);

          if (weighInThresholds) {
            let resp = await fetch(`/api/posts/${data.id}/weigh-in-thresholds`, {
              method: 'POST',
              body: JSON.stringify({
                thresholds: weighInThresholds ? weighInThresholds : undefined,
              }),
              headers: {
                'Content-Type': 'application/json',
              },
            });
          }
          toast.add({
            severity: 'success',
            summary: isReply ? 'Reply created' : 'Post created',
            life: 7000,
          });

          // emit event for add replyList tree
          if (isReply) {
            eventBus.emit('add-reply', { parentId: data.id, newReply: data });
          }

          return response;
        } else {
          commit('setUserDataError', data);
        }
      }
    } catch (error) {
      console.log('error', error);
      commit('setUserDataError', error);
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: error,
        life: 7000,
      });
    }
  },
  async updatePost({ commit }, { title, text, attachedFileIds, isAnyoneCanReply, id, urls, tags, toast }) {
    try {
      const payload = Object.fromEntries(
        Object.entries({
          title,
          text,
          attachedFileIds,
          isAnyoneCanReply,
          urls: urls?.[0]
            ? [
                {
                  url: urls[0].url,
                  title: urls[0].title,
                  description: urls[0].description,
                  imageUrl: urls[0].imageUrl,
                  isDisabledPreview: urls[0].isDisabledPreview,
                },
              ]
            : undefined,
          tags: Array.isArray(tags) ? tags : undefined,
        }).filter(([_, value]) => value !== undefined && value !== null),
      );

      const response = await fetch(`/api/posts/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.status) {
        authErrorHandler(response.status);
      }
      if (response.status === 429) {
        toast.add({
          severity: 'error',
          summary: 'Sorry, you have reached the max number of posts allowed for users with your score',
          life: 7000,
        });
        return;
      }

      const data = await response.json();

      if (
        data.statusCode === 409 ||
        data.message === 'A post may not be edited after it has been responded or reacted to'
      ) {
        toast.add({
          severity: 'error',
          summary: "Can't edit post",
          detail: data.message,
          life: 7000,
        });
        return;
      }

      if (data.error) {
        console.log('error', data.message);
      } else {
        const payload = { data: data, type: 'update' };
        commit('postPost', payload);
        commit('setPost', data);
        // emit event for add replyList tree
        if (data.type === 'reply') {
          eventBus.emit('add-reply', { parentId: data.id, newReply: data });
        }

        if (!data.statusCode) {
          toast.add({
            severity: 'success',
            summary: 'Post updated',
            life: 7000,
          });
        } else {
          commit('setUserDataError', data);
        }
      }
    } catch (error) {
      console.log('error', error);
      commit('setUserDataError', error);
    }
  },
  async deletePost({ commit }, { postId, toast, type }) {
    let data = null;
    try {
      const response = await fetch(`/api/posts/${postId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.status && response.status === 401) {
        authErrorHandler(response.status);
      }
      if (!response.ok) {
        data = await response.json();
      }
      if (response.ok) {
        const typePost = type.charAt(0).toUpperCase() + type.slice(1);
        if (toast) {
          toast.add({
            severity: 'success',
            summary: `${typePost} deleted`,
            life: 3000,
          });
        }

        commit('removePost', postId);

        // if (type === "reply") {
        //   //commit("setBlockOnReplies", [postId]);
        // } else {

        // }
      } else {
        toast.add({
          severity: 'error',
          summary: data.message,
          life: 7000,
        });
        throw new Error('Failed to delete the post');
      }
    } catch (error) {
      console.error('Error in deletePost action:', error.message);
    }
  },
  startGlobalTimer({ commit }) {
    setInterval(() => {
      commit('updateNow');
    }, 60000);
  },
  async setUserReplies({ commit }, userId) {
    const limit = 20;
    const response = await fetch(`/api/users/${userId}/replies?limit=${limit}`);
    let replies = await response.json();
    if (replies.statusCode) {
      authErrorHandler(replies.statusCode);
    }
    if (replies.count > 0) {
      commit('setUserReplies', replies.results);
      commit('setTotalCountPosts', replies.count);
    }
    return replies;
  },
  async setUserReposts({ commit }, userId) {
    const limit = 10;
    const response = await fetch(`/api/users/${userId}/reposts?limit=${limit}`);
    let reposts = await response.json();
    if (reposts.statusCode) {
      authErrorHandler(reposts.statusCode);
    }
    if (reposts.count > 0) {
      commit('setUserReposts', reposts.results);
      commit('setTotalCountPosts', reposts.count);
    }
    return reposts;
  },

  async setReactionPost({ commit }, payload) {
    const response = await fetch(`/api/posts/${payload.id}/react`, {
      method: 'POST',
      body: JSON.stringify({
        values: payload.values,
        description: payload.description || null,
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Sez-Platform': 'web',
      },
    });
    const responseData = await response.json();
    if (responseData.statusCode) {
      authErrorHandler(responseData.statusCode);
    }
    return responseData;
  },

  async setToggleRepost({ commit }, payload) {
    const response = await fetch(payload.repostedPostId ? `/api/posts/${payload.id}/undo-repost` : `/api/posts/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        repostedPostId: payload.repostedPostId ? undefined : payload.id,
      }),
    });
    let res = await response.json();
    if (res.statusCode) {
      authErrorHandler(res.statusCode);
    }
    commit('removePost', res[0]);
    return res;
  },

  async setOnlyUserPosts({ commit }, { id, limit, channel }) {
    const params = new URLSearchParams({
      limit: limit || '15',
      channelId: channel ? channel.id : id,
      onlyPosts: true,
    }).toString();
    let response = await fetch(`/api/posts?${params}`);
    let posts = await response.json();
    if (posts.statusCode) {
      authErrorHandler(posts.statusCode);
    }
    if (posts.count > 0) {
      commit('setOnlyUserPosts', posts.results);
      commit('setTotalCountPosts', posts.count);
    }
    return posts;
  },

  async fetchReputationCategories({ commit }) {
    const { data, status, error, refresh } = await useAPI(`/users/reputation-categories`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    commit('setReputationCategories', data);
  },
  async fetchReportBotId({ commit }, id) {
    commit('setReportBotId', id);
  },

  async fetchUsernameData({ commit }, username) {
    try {
      const response = await fetch(`/api/users/username/${username}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.status) {
        authErrorHandler(response.status);
      }
      if (response.ok) {
        const data = await response.json();
        commit('setUsernameData', data);
      } else {
        throw new Error('Failed to username');
      }
    } catch (error) {
      console.error('Error:', error.message);
    }
  },

  async blockUserOnReplies({ commit }, payload) {
    try {
      const { id, blocked, toast } = payload;

      const response = await fetch(`/api/posts/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(blocked),
      });

      if (!response.ok) {
        console.error(`Failed to update post with ID ${id}: ${response.statusText}`);
      } else {
        const data = await response.json();
        // commit("setBlockOnReplies", blocked.blockedUsersIds);
        toast.add({
          severity: 'success',
          summary: 'Blocked!',
          detail: 'The user has been blocked from replying to this post.',
          life: 3000,
        });
        return data;
      }
    } catch (error) {
      console.error('Error updating post:', error);
      throw error;
    }
  },

  async blockUnblockUser({ commit }, payload) {
    try {
      const { id, actionType, toast } = payload;
      const response = await fetch(`/api/users/${id}/${actionType}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        console.error(`Failed to ${actionType} user with ID ${id}: ${response.statusText}`);
      } else {
        const data = await response.json();
        //commit("setBlockOnReplies", blocked.blockedUsersIds);
        const message =
          actionType === 'block'
            ? "You've successfully blocked this user. Their posts and interactions are now hidden."
            : "You can now view and interact with this user's posts again.";
        toast.add({
          severity: 'success',
          summary: `User ${actionType}ed`,
          detail: message,
          life: 3000,
        });
        return data;
      }
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  },

  async createShortLink({ commit }, id) {
    let response = await fetch(`/api/links`, {
      method: 'POST',
      body: JSON.stringify({
        postId: id,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    return data;
  },

  async checkVisitLink({ commit }, id) {
    let response = await fetch(`/api/links/${id}/visit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    return data;
  },

  setIsReply({ commit }, isReply) {
    commit('setIsReply', isReply);
  },

  removeReportedPost({ commit }, postId) {
    commit('removeReportedPost', postId);
  },

  removeReportedPostWithCollection({ commit }, { postId, collectionName }) {
    commit('removeReportedPostWithCollection', { postId, collectionName });
  },

  setReaction({ commit }, post) {
    commit('setReaction', post);
  },

  setUpdateStatusReply({ commit }, status) {
    commit('addReplyPostStatus', status);
  },

  addCollection({ commit }, { collectionName, data }) {
    commit('setCollection', { collectionName, data });
  },

  async fetchSearchResults({ commit }, query) {
    if (query.trim().length < 2) {
      commit('clearSearchResults');
      return;
    }

    try {
      let users = [];
      let posts = [];

      // Проверяем наличие символа @ в начале запроса для поиска пользователей
      if (query.startsWith('@')) {
        // Поиск пользователей с автодополнением - запрос без символа @
        const cleanQuery = query.substring(1);
        const userParams = new URLSearchParams({ search: cleanQuery, autocomplete: 'true' });
        const userResponse = await fetch(`/api/users?${userParams}`);
        const userData = await userResponse.json();
        users = Array.isArray(userData) ? userData : userData.results || [];
      } else {
        // Параллельные запросы для поиска пользователей и постов
        const [userResponse, postResponse] = await Promise.all([
          fetch(`/api/users?search=${query}`),
          fetch(`/api/search?query=${query}`),
        ]);

        const userData = await userResponse.json();
        const postData = await postResponse.json();

        users = Array.isArray(userData) ? userData : userData.results || [];
        posts = Array.isArray(postData)
          ? postData.filter(item => item.collection === 'posts').map(item => item.render)
          : [];
      }

      commit('setSearchResults', { users, posts });
    } catch (error) {
      console.error('Error fetching search results:', error);
      commit('clearSearchResults');
    }
  },
  updateSearchText({ commit }, text) {
    commit('setSearchText', text);
  },
  clearCollection({ commit }, collectionName) {
    commit('clearCollection', collectionName);
  },

  async addUserUnreadPosts({ commit }, params) {
    if (!params || !params.id) {
      console.error('Missing required parameters for fetchUserUnreadPosts');
      return { results: [] };
    }

    try {
      const apiParams = {
        authorUserId: params.id,
        offset: params.offset || 0,
        limit: params.limit || 15,
      };

      const response = await fetchUserUnreadPosts(apiParams);

      if (response.statusCode) {
        authErrorHandler(response.statusCode);
        return null;
      }

      if (response && response.results) {
        commit('setUnreadPosts', response.results);
        if (response.count) {
          commit('setTotalCountPosts', response.count, { root: true });
        }
      }
      return response;
    } catch (error) {
      console.error('Error fetching unread posts:', error);
      return { results: [] };
    }
  },
};
